import { render, staticRenderFns } from "./Loss.vue?vue&type=template&id=839109c2&scoped=true&lang=pug&"
import script from "./Loss.vue?vue&type=script&lang=ts&"
export * from "./Loss.vue?vue&type=script&lang=ts&"
import style0 from "./Loss.vue?vue&type=style&index=0&id=839109c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839109c2",
  null
  
)

export default component.exports